import BubbleCommon, {
  aigcDeepseekAnalysisTargetPromptTips,
} from '@op/components/BubbleCommon';
import React from 'react';
import { Form, TextArea } from 'tea-component';
import { useIntl } from 'umi';

export default function AnalysisTarget({
  prompt,
  setPrompt,
}: {
  prompt: string;
  setPrompt: (text: string) => void;
}) {
  const { formatMessage } = useIntl();

  return (
    <Form.Item
      showStatusIcon={false}
      className="dbo-prompt-form-item"
      label={
        <div className="item-label">
          <BubbleCommon
            tipsMap={aigcDeepseekAnalysisTargetPromptTips}
            placement="top"
          >
            {formatMessage({ id: 'Analysis Target' })}
          </BubbleCommon>
        </div>
      }
    >
      <TextArea
        className="dbo-aigc-modal-textarea"
        style={{ height: '100px' }}
        value={prompt}
        placeholder={`${formatMessage({
          id: 'Input relevant background knowledge or key focus areas here to generate a more tailored summary.',
        })}\n${formatMessage({
          id: 'Note: Format restrictions or specific template requests may cause processing issues.',
        })}`}
        onChange={(value) => {
          setPrompt(value);
        }}
      />
    </Form.Item>
  );
}
